export const LOGIN_USER = 'LOGIN_USER';
export const LOGIN_USER_ERR = 'LOGIN_USER_ERR';
export const GET_USERS = 'GET_USERS';
export const GET_USERS_ERR = 'GET_USERS_ERR';